export default __webpack_public_path__ + "locales/ko-KR/DowngradePlanDialog.json?hash=9184fbebe443c3bf8e2a6b10163f1d70";